import { makeEnum } from '@transcend-io/type-utils';

/**
 * Fields to order a system discovery result when paginating
 */
export enum SystemDiscoveryResultOrderField {
  /** The name of the recommended system */
  Name = 'name',
  /** The sensitivity of the recommended system */
  Sensitivity = 'sensitivity',
  /** The alphabetical order of system names that discovered this resource */
  DiscoveredBy = 'discoveredBy',
  /** The created at date of the recommended system discovery */
  CreatedAt = 'createdAt',
  /** The updated at date of the recommended system discovery */
  UpdatedAt = 'updatedAt',
}

/**
 * The status of a classified silo discovery plugin result
 */
export const SystemDiscoveryResultStatus = makeEnum({
  /** The recommendation is pending review */
  Pending: 'PENDING',
  /** The recommendation has been ignored and will not show up for future review */
  Ignored: 'IGNORED',
  /** The recommendation has been marked as duplicate and will not show up for future review */
  Duplicate: 'DUPLICATE',
});

/**
 * Type override
 */
export type SystemDiscoveryResultStatus =
  (typeof SystemDiscoveryResultStatus)[keyof typeof SystemDiscoveryResultStatus];
